import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';

function FormFolderPickerRadios({ control, posts }: any) {
  const intl = useIntl();

  return (
    <Controller
      name="post_record_id"
      control={control}
      render={({ field: { onChange, value } }: any) => (
        <FormControl component="fieldset">
          <RadioGroup
            aria-label={intl.formatMessage({ id: 'POST_FORM.CHOOSE_A_FOLDER' })}
            name="post_record_id"
            value={value}
            onChange={onChange}
          >
            <FormControlLabel
              value=""
              control={<Radio color="primary" />}
              label={intl.formatMessage({ id: 'NONE' })}
            />
            {posts.map((post: any) => (
              <FormControlLabel
                key={`folder-name-${post.id}`}
                value={post.id.toString()}
                control={<Radio color="primary" />}
                label={post.title}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  );
}

export default FormFolderPickerRadios;
